<template>
  <div>
    <el-button type="primary" @click="nextTurn" v-if="showHints">
      {{ nextTurnClicked ? `continua (${nextDelay} sec)` : "Prossimo turno" }}
      <i
        class="el-icon-right"
      ></i>
    </el-button>
  </div>
</template>

<script>
import Vue from "vue";
import CurrentPlayer from "./CurrentPlayer";
export default CurrentPlayer;
</script>

<style scoped>
.word {
  padding: 5px;
  border-style: dashed;
  border-color: #e9d5a3;
  border-width: 2px 0px;
}
.word span {
  font-weight: bold;
}
</style>